import { TypographyOptions } from '@mui/material/styles/createTypography';

const typography: TypographyOptions = {
  fontFamily: [
    'Cera Pro',
    'Gotham Pro',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontSize: '20px',
    fontWeight: 500,
  },
  h2: {
    fontSize: '20px',
    fontWeight: '400',
  },
  h3: {
    fontSize: '18px',
    fontWeight: 400,
  },
  h4: {
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h5: {
    fontSize: '1.0625rem',
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 1.25,
  },
  body1: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  body2: {
    fontSize: '14px',
    fontWeight: 400,
  },
  button: {
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
  },
  caption: {
    fontSize: '12px',
    fontWeight: 500,
  },
};

export default typography;
